<template>
    <el-popover :key="key" v-bind="$attrs" popper-class="myPopover" @show="showHandler" @hide="hideHandler">
        <template slot="reference">
            <slot></slot>
        </template>
        <div class="clickMenu" :style="{width: menuWidth}">
            <div v-for="item in menuList"
                 :key="item.key"
                 v-show="getVisible(item.visible) && menuCheck(item)">
                <!-- 分割线 -->
                <div v-if="item.needDL" style="line-height: 10px;">
                    <el-divider></el-divider>
                </div>
                <!-- 选项 -->
                <div v-else class="clickMenuItem">
                    <!-- 无子菜单选项 -->
                    <el-button v-if="isEmpty(item.children)"
                               :disabled="getDisable(item.disabled)"
                               type="text"
                               @click.stop="optionClickHandler(item)"
                               :size="getSize(item.size)">
                        <slot v-bind:item="item" name="option">
                            <!-- 选中状态 -->
                            <div v-if="item.selected" class="clickMenuItem_selected_icon">
                                <i class="el-icon-check"></i>
                            </div>
                            <div :class="item.selected ? 'clickMenuItem_selected' : 'clickMenuItem_no_selected'">
                                <svg-icon style="font-size: 7px" v-if="!isEmpty(item.icon)" :icon-class="item.icon"></svg-icon>
                                {{getDisplayText(item.displayText)}}
                            </div>
                        </slot>
                    </el-button>
                    <!-- 有子菜单选项 -->
                    <my-menu v-else :menu-list="item.children" :parent="item" :level="level + 1" :trigger="getDisable(item.disabled) ? 'click' : getTrigger(item)" placement="right-start" @openChange="visibleChange" @menu-click="optionClickHandler">
                        <template>
                            <el-button :disabled="getDisable(item.disabled)"
                                       type="text"
                                       @click.stop="optionClickHandler(item)"
                                       :size="getSize(item.size)">
                                <slot name="option" v-bind:item="item">
                                    <div style="width: 70%;display: inline-block">
                                        <!-- 选中状态 -->
                                        <div v-if="item.selected" class="clickMenuItem_selected_icon">
                                            <i class="el-icon-check"></i>
                                        </div>
                                        <div :class="item.selected ? 'clickMenuItem_selected' : 'clickMenuItem_no_selected'">
                                            <svg-icon style="font-size: 7px" v-if="!isEmpty(item.icon)" :icon-class="item.icon"></svg-icon>
                                            {{getDisplayText(item.displayText)}}
                                        </div>
                                    </div>
                                    <div style="width: 30%;text-align: right;display: inline-block">
                                        <i class="el-icon-caret-right"></i>
                                    </div>
                                </slot>
                            </el-button>
                        </template>
                    </my-menu>
                </div>
            </div>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: "MyMenu",
        props: {
            /* 菜单item可选项 */
            // sss: {
            //     key: '',  // 唯一键 必填
            //     displayText: '菜单1', // 选项显示名 选填
            //     clickHandler: undefined, //点击事件处理器，和 clickEventName 2选1即可，优先clickHandler 选填
            //     clickEventName: undefined, // 点击选项时对外发布的事件，和 clickHandler 2选1即可，优先clickHandler 选填
            //     size: 'small', // 选项大小，同elementUI的size属性 选填
            //     icon: undefined, // 选项图标 选填
            //     disabled: false, // 是否禁用 选填
            //     visible: true, // 是否显示 选填
            //     trigger: 'click', //  有子菜单时的展开触发条件，菜单项大于等于三级建议使用click 选填
            //     selected: false, // 是否显示选中状态 选填
            //     needDL: false, // 是否需要分界线 选填 (该值为true时，其他所有属性失效)
            //     group: false, // 分组 选填
            //     children:[], // 子菜单数组 选填
            // },
            // 菜单列表
            menuList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            // 回传显示状态（不控制显隐）.sync
            show: {
                type: Boolean,
            },
            // 父级节点 点击处理用
            parent: {
                type: Object,
            },
            // 菜单等级（务必不要配置该属性）
            level: {
                type: Number,
                default: 0
            },
            menuWidth: {
                type: String,
                default: '180px'
            },
            // 控制菜单项显隐
            menuCheck: {
                type: Function,
                default: () => {
                    return true;
                }
            }
        },
        data: function (){
            return {
                // 菜单的展开数量
                visible: 0,
                key: new Date().getTime() + '_' + Math.floor(Math.random() * 10000000000)
            }
        },
        computed: {

        },
        methods: {
            // 获取子菜单触发条件（默认click）
            getTrigger: function (item) {
                return this.isEmpty(item.trigger) ? 'click' : item.trigger;
            },
            isEmpty: function (obj) {
                return this.$comUtils.isEmpty(obj);
            },
            // 获取菜单项大小（默认medium）
            getSize: function (val) {
                return this.isEmpty(val) ? 'medium' : val;
            },
            // 获取菜单项禁用状态（默认false）
            getDisable: function (val) {
                return this.isEmpty(val) ? false : val;
            },
            // 获取菜单项显示名（默认''）
            getDisplayText: function (val) {
                return this.isEmpty(val) ? '' : val;
            },
            // 获取是否显示
            getVisible: function (val) {
                return this.isEmpty(val) ? true : val;
            },
            // 菜单项点击处理（参数：点击的菜单项，父菜单列表）
            optionClickHandler: function (item, parents) {
                parents = this.isEmpty(parents) ? [] : parents;
                if (!this.isEmpty(item.clickHandler)) {
                    if (this.level === 0) {
                        item.clickHandler(item, [...parents]);
                    } else {
                        item.clickHandler(item, [this.parent, ...parents]);
                    }
                } else if (!this.isEmpty(item.clickEventName)) {
                    if (this.level === 0) {
                        this.$emit(item.clickEventName, item, [...parents]);
                    } else {
                        this.$emit(item.clickEventName, item, [this.parent, ...parents]);
                    }
                } else {
                    console.log('【' + item.key + '】无事件处理！')
                }
            },
            // 菜单展开时的处理
            showHandler: function () {
                this.visible += 1;
                this.$emit('openChange', 1, this.visible);
            },
            // 菜单隐藏时的处理
            hideHandler: function () {
                this.visible -= 1;
                this.$emit('openChange', -1, this.visible);
            },
            // 子菜单显隐时的处理
            visibleChange: function (num) {
                this.visible += num;
                this.$emit('openChange', num, this.visible);
            }
        },
        watch: {
            // 对外发布菜单展开状态
            visible: function (nv, ov) {
                // console.log('level-' + this.level + ' ',nv, ov);
                if (nv === 0) {
                    this.$emit('update:show', false);
                } else {
                    this.$emit('update:show', true);
                }
            },
            // 实时刷新菜单
            menuList: {
                handler: function (nv, ov) {
                    // console.log('更新菜单');
                    this.key = new Date().getTime() + '_' + Math.floor(Math.random() * 10000000000);
                    this.visible = 0;
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    /* 列菜单样式 */
    .clickMenu {
        width: 180px;
        padding: 0px;
    }
    /* 列菜单选项样式 */
    .clickMenuItem {
        height: 20px;
        width: 100%;
        padding-top: 5px;
        /*border-top: 1px solid #9c9c9c;*/
    }
    /* 列菜单选项按钮样式 */
    .clickMenuItem .el-button--text {
        font-size: 13px;
        text-align: left;
        color: black;
        padding-top: 3px;
        line-height: 14px;
        padding-bottom: 3px;
        width: 100%;
        border-radius: 0px;
    }
    /* 菜单禁用样式 */
    .clickMenuItem .is-disabled {
        color: #9c9c9c !important;
    }
    .clickMenuItem:first-of-type {
        border-top: none;
    }
    /* 列菜单悬停样式 */
    .clickMenuItem .el-button--text:hover{
        background-color: rgba(156, 156, 156, 0.42);
    }
    /* 列禁用菜单悬停样式 */
    .clickMenuItem .is-disabled:hover {
        background: none !important;
    }
    /* 选项选中样式 */
    .clickMenuItem_selected {
        color: #1c7cff !important;
        display: inline-block;
    }
    .clickMenuItem_no_selected {
        margin-left: 18px;
        display: inline-block;
    }
    .clickMenuItem_selected_icon {
        color: #1c7cff !important;
        display: inline-block;
        width: 18px;
        height: 100%;
        font-weight: bolder;
    }

    ::v-deep .el-divider--horizontal {
        vertical-align: middle;
        margin-bottom: 0px;
        margin-top: 5px;
    }
</style>
<style>
    /* 自定义弹框样式 */
    .myPopover {
        min-width: unset;
        padding: 2px;
        box-shadow: 0 4px 5px rgba(0, 0, 0, .3), 0 0 4px rgba(0, 0, 0, .2);
        border-radius: 0px;
    }
</style>
